export default __webpack_public_path__ + "static/media/020-blinds.861f7510.svg";